import { Input, Spinner } from '@cloudscape-design/components';
import { Modal } from '../../../components/Modal';
import { useCallback, useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { createEvent } from '../../../common/api/events';
import { useNavigate } from 'react-router-dom';

export type CreateEventModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

export function CreateEventModal(props: CreateEventModalProps) {
  const [name, setName] = useState('');
  const navigate = useNavigate();

  const create = useMutation({
    mutationFn: createEvent,
    onSuccess: (data) => {
      props.setOpen(false);
      setName('');
      navigate(`/manage/events/${data.eventUuid}`);
    },
  });
  const loading = create.isPending;

  const triggerCreate = useCallback(() => {
    if (loading) {
      return;
    }

    create.mutate({
      name: name.trim(),
    });
  }, [create, name, loading]);

  return (
    <Modal isOpen={props.open} onClose={() => props.setOpen(false)}>
      <div className="px-4 py-4 space-y-2 text-white rounded-lg mx-auto my-auto grid grid-cols-1 gap-4">
        <div className="flex flex-col items-center text-center">
          <form className="space-y-4 items-center text-left">
            <div>
              <label className="block text-sm font-medium text-gray-200">Name</label>
              <Input
                name="name"
                disabled={loading}
                placeholder="Event name..."
                value={name}
                onChange={(e) => {
                  setName(e.detail.value);
                }}
              />
            </div>
            <div className="text-center">
              <button
                className={`text-black font-semibold text-sm py-2 px-2 rounded ${
                  loading || !name.trim() ? 'bg-gray-400' : 'bg-white hover:bg-gray-200'
                }`}
                disabled={loading || !name.trim()}
                onClick={(e) => {
                  e.preventDefault();
                  triggerCreate();
                }}
                onKeyDown={(e) => {
                  e.preventDefault();
                  if (e.key === 'Enter') {
                    triggerCreate();
                  }
                }}
              >
                <div className="flex items-center justify-center w-full">
                  <span>Create</span>
                  {loading ? (
                    <div className="ml-2 w-4">
                      <Spinner />
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </button>
              {/* TODO display errors: {error && (
                <div className="mt-4">
                  <ErrorTurn error={error} />
                </div>
              )} */}
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
